module.exports = __webpack_public_path__ + "static/surgery_hero-7ecc798b20181a40e7fd28592fe1440c.png";